import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the view for taxable earnings table.
 */
export default class tableTaxableEarningsView extends JetView {
    /**
     * Configures the datatable for displaying taxable earnings.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        const cur_user = this.getParam('user', true); // Get current user parameter

        /**
         * Marks new entries with specific colors based on their value.
         * @param {string} value - The value to check.
         * @returns {string} The corresponding color for the value.
         */
        function mark_new(value) {
            if (value == 'Entrada') {
                return 'lightgreen'; // Color for 'Entrada'
            } else {
                if (value == 'Salida') {
                    return 'highlight'; // Color for 'Salida'
                } else {
                    return ''; // Default color
                }
            }
        }

        return {
            view: 'datatable', // Type of view
            id: 'datatable', // Unique identifier for the datatable
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling
            height: screen.width < 820 ? 450 : 0, // Conditional height based on screen width
            columns: [
                // Column definitions for the datatable
                {
                    id: 'TicketId',
                    header: _('Ticket ID'), // Localized header
                    width: 100,
                    sort: 'int', // Sorting type
                },
                {
                    id: 'CreatedLocalDate',
                    header: _('Fecha de creación'), // Localized header
                    fillspace: 0,
                    minWidth: 0,
                    width: 150,
                    sort: 'text',
                    format: dateFormat, // Date formatting
                },
                {
                    id: 'UserId',
                    header: _('ID Usuario'), // Localized header
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'BetShop',
                    header: _('Punto de venta'), // Localized header
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'ValueBet',
                    header: _('Valor Apostado'), // Localized header
                    width: 100,
                    sort: 'int',
                    format: webix.Number.numToStr({
                        // Number formatting
                        groupDelimiter: ',',
                        groupSize: 3,
                        decimalDelimiter: '.',
                        decimalSize: 2,
                    }),
                },
                {
                    id: 'ValuePrize',
                    header: _('Valor Premio'), // Localized header
                    width: 100,
                    sort: 'int',
                    format: webix.Number.numToStr({
                        // Number formatting
                        groupDelimiter: ',',
                        groupSize: 3,
                        decimalDelimiter: '.',
                        decimalSize: 2,
                    }),
                },
                {
                    id: 'Earnings',
                    header: _('Ganancia'), // Localized header
                    width: 100,
                    sort: 'int',
                    format: webix.Number.numToStr({
                        // Number formatting
                        groupDelimiter: ',',
                        groupSize: 3,
                        decimalDelimiter: '.',
                        decimalSize: 2,
                    }),
                },
                {
                    id: 'Tax',
                    header: _('Impuesto'), // Localized header
                    width: 100,
                    sort: 'int',
                    format: webix.Number.numToStr({
                        // Number formatting
                        groupDelimiter: ',',
                        groupSize: 3,
                        decimalDelimiter: '.',
                        decimalSize: 2,
                    }),
                },
            ],
            ready: function () {
                // Event triggered when the datatable is ready
                if (!this.count()) {
                    // Check if there are no items
                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                    this.showOverlay(
                        // Show overlay message
                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                            _('No hay datos') + // Localized no data message
                            '</div>',
                    );
                }
            },
            tooltip: true, // Enable tooltips
            math: true, // Enable mathematical operations
            loadahead: devConfig.getDefaultDataFetch(), // Data fetching configuration
            pager: 'pagerA', // Pager ID
            // API endpoint for fetching data
            url: devConfig.geturlApi() + 'es/TaxableEarnings/GetTaxableEarnings',
        };
    }

    /**
     * Initializes the datatable and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        var url = grid.data.url; // Store the data URL
        var filter = ''; // Initialize filter string
        const cur_user = this.getParam('user', true); // Get current user parameter

        // Event listener for filtering taxable earnings
        this.on(this.app, 'taxableEarnings:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string for filters
            for (var i = 0; i < object.length; i++) {
                // Iterate over filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'CreatedLocalDate') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query
                    } else {
                        if (object[i][0] == 'ModifiedLocalDate') {
                            var date = object[i][1].split(' - '); // Split date range
                            string1 = string1 + '&dateFrom2=' + date[0]; // Add dateFrom2 to query
                            string1 = string1 + '&dateTo2=' + date[1]; // Add dateTo2 to query
                        } else {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate over nested entries
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter string
        });

        // Event listener for sorting the datatable
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event listener for item click in the datatable
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data for selected player
            );
        });
    }
}

// FILE DOCUMENTED
